// Bespoke brand patterns for header/footer — inline SVG, zero network cost.
// Flip ACTIVE_PATTERN to switch the whole site's header/footer texture.

export const ACTIVE_PATTERN = "baguette"; // "guilloche" | "artdeco" | "baguette"

export const PATTERNS = {
  guilloche: {
    header: (
      <pattern id="pat-g-head" width="48" height="24" patternUnits="userSpaceOnUse">
        <path
          d="M0 6 Q12 0, 24 6 T48 6 M0 18 Q12 12, 24 18 T48 18 M-12 12 Q0 6, 12 12 T36 12"
          stroke="#E8CC6E" strokeOpacity="0.055" strokeWidth="0.65" fill="none"
        />
      </pattern>
    ),
    footer: (
      <pattern id="pat-g-foot" width="64" height="32" patternUnits="userSpaceOnUse">
        <path
          d="M0 8 Q16 0, 32 8 T64 8 M0 24 Q16 16, 32 24 T64 24 M-16 16 Q0 8, 16 16 T48 16"
          stroke="#E8CC6E" strokeOpacity="0.075" strokeWidth="0.75" fill="none"
        />
      </pattern>
    ),
  },
  artdeco: {
    header: (
      <pattern id="pat-a-head" width="40" height="20" patternUnits="userSpaceOnUse">
        <path
          d="M20 0 L10 20 M20 0 L15 20 M20 0 L20 20 M20 0 L25 20 M20 0 L30 20 M10 20 A12 12 0 0 1 30 20"
          stroke="#C9A227" strokeOpacity="0.05" strokeWidth="0.6" fill="none"
        />
      </pattern>
    ),
    footer: (
      <pattern id="pat-a-foot" width="56" height="28" patternUnits="userSpaceOnUse">
        <path
          d="M28 0 L14 28 M28 0 L21 28 M28 0 L28 28 M28 0 L35 28 M28 0 L42 28 M14 28 Q28 14 42 28 M7 28 Q28 0 49 28"
          stroke="#E8CC6E" strokeOpacity="0.065" strokeWidth="0.7" fill="none"
        />
      </pattern>
    ),
  },
  baguette: {
    header: (
      <pattern id="pat-b-head" width="32" height="32" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <rect x="4" y="4" width="24" height="24" stroke="#E8CC6E" strokeOpacity="0.045" strokeWidth="0.55" fill="none" />
        <line x1="4" y1="4" x2="28" y2="28" stroke="#E8CC6E" strokeOpacity="0.035" strokeWidth="0.5" />
        <line x1="28" y1="4" x2="4" y2="28" stroke="#E8CC6E" strokeOpacity="0.035" strokeWidth="0.5" />
      </pattern>
    ),
    footer: (
      <pattern id="pat-b-foot" width="44" height="44" patternUnits="userSpaceOnUse">
        <rect x="2" y="2" width="40" height="40" stroke="#E8CC6E" strokeOpacity="0.06" strokeWidth="0.65" fill="none" />
        <rect x="8" y="8" width="28" height="28" stroke="#C9A227" strokeOpacity="0.04" strokeWidth="0.5" fill="none" />
        <line x1="2" y1="2" x2="8" y2="8" stroke="#E8CC6E" strokeOpacity="0.05" strokeWidth="0.5" />
        <line x1="42" y1="2" x2="36" y2="8" stroke="#E8CC6E" strokeOpacity="0.05" strokeWidth="0.5" />
        <line x1="2" y1="42" x2="8" y2="36" stroke="#E8CC6E" strokeOpacity="0.05" strokeWidth="0.5" />
        <line x1="42" y1="42" x2="36" y2="36" stroke="#E8CC6E" strokeOpacity="0.05" strokeWidth="0.5" />
      </pattern>
    ),
  },
};

const ID_PREFIX = { guilloche: "g", artdeco: "a", baguette: "b" };

// Light-ivory variant of the chosen baguette facet — echoes the header/footer
// texture behind page heroes without darkening them.
export const patternLight = {
  def: (
    <pattern id="pat-b-light" width="44" height="44" patternUnits="userSpaceOnUse">
      <rect x="2" y="2" width="40" height="40" stroke="#A37E17" strokeOpacity="0.085" strokeWidth="0.65" fill="none" />
      <rect x="8" y="8" width="28" height="28" stroke="#A37E17" strokeOpacity="0.055" strokeWidth="0.5" fill="none" />
      <line x1="2" y1="2" x2="8" y2="8" stroke="#A37E17" strokeOpacity="0.06" strokeWidth="0.5" />
      <line x1="42" y1="2" x2="36" y2="8" stroke="#A37E17" strokeOpacity="0.06" strokeWidth="0.5" />
      <line x1="2" y1="42" x2="8" y2="36" stroke="#A37E17" strokeOpacity="0.06" strokeWidth="0.5" />
      <line x1="42" y1="42" x2="36" y2="36" stroke="#A37E17" strokeOpacity="0.06" strokeWidth="0.5" />
    </pattern>
  ),
  id: "pat-b-light",
};

export const patternFor = (surface, key = ACTIVE_PATTERN) => ({
  def: PATTERNS[key][surface],
  id: `pat-${ID_PREFIX[key]}-${surface === "header" ? "head" : "foot"}`,
});

export const PatternLayer = ({ pattern, boost = false }) => (
  <svg className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true">
    <defs>{pattern.def}</defs>
    <rect width="100%" height="100%" fill={`url(#${pattern.id})`} />
    {boost && <rect width="100%" height="100%" fill={`url(#${pattern.id})`} />}
  </svg>
);
